import { useContext } from "react";

import { RuntimeConfigContext } from "./RuntimeConfigContext";

export function useRuntimeConfig() {
  return useContext(RuntimeConfigContext);
}
